import React from 'react';

// Swiper js library
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// CSS file
import '../../styles/components/EventDescription.css';

import { Navigation, Pagination, Autoplay } from 'swiper/modules';

export default function EventDescriptionCarousel({
    eventPoster = [
        'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?q=80&w=1112&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        'https://images.unsplash.com/photo-1531058020387-3be344556be6?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        'https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
    ]
}) {
    return (
        <div className="event-description-carousel">
            <div className="description-carousel-section">
                <Swiper
                    spaceBetween={50}
                    centeredSlides={true}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false
                    }}
                    // autoplay={false}
                    navigation={false}
                    pagination={{ clickable: true }}
                    loop={false}
                    modules={[Navigation, Pagination, Autoplay]}
                    slidesPerView={'auto'}
                    breakpoints={{
                        480: { slidesPerView: 'auto' },
                        768: { slidesPerView: 'auto' },
                        1024: { slidesPerView: 'auto' },
                        1200: { slidesPerView: 'auto' }
                    }}
                >
                    {eventPoster.map((event, index) => (
                        <SwiperSlide key={index} className="swiper-slide-event-description">
                            <div className="event-description-photos-carousel">
                                <img
                                    src={event}
                                    alt="Event Carousell"
                                    className="event-description-image"
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
